import { render, staticRenderFns } from "./CaseTax.vue?vue&type=template&id=788072bc&lang=pug"
import script from "./CaseTax.vue?vue&type=script&lang=js"
export * from "./CaseTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports